import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BlockCommand {}

const client = createClient('/rest/operator-api/charging-stations');

export const block: SaveOperation<BlockCommand, void, string> = postRequestFactory<BlockCommand, void, string>(client, {
  pattern: '/{chargingStationId}/block',
  permissionId: commandPermissions.BLOCK_CHARGING_STATION
});
